import React from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import ListadoVacas from './ListadoVacas';
const Vacas = () => {
		return (
			<div>
				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item"><Link to="/">Vacas Registradas</Link></li>
					<li className="breadcrumb-item active">Active Page</li>
				</ol>  
				<h1 className="page-header">Vacas Registradas</h1>
				<Panel>
					<PanelHeader></PanelHeader>
					<PanelBody>
					<div className="row">
						<div className="col-md-12" style={{borderRight : '2px solid #dadada'}}>
							<ListadoVacas />
						</div>
					</div>
					</PanelBody>
				</Panel>
			</div>
		)
};

export default Vacas;